import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivateFn } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);
  const authService = inject(AuthService);

  // Check if we're in the browser environment
  if (isPlatformBrowser(platformId)) {
    // Try to restore session first
    const sessionRestored = authService.restoreSession();
    
    // Check authentication status
    const isAuthenticated = authService.isAuthenticated();
    const hasPendingCreds = authService.hasPendingCredentials();

    if (isAuthenticated || hasPendingCreds) {
      // Save current URL for refresh handling
      authService.saveCurrentUrl(state.url);
      return true;
    } else {
      // Redirect to home (login) and include the attempted URL as returnUrl
      return router.createUrlTree(['/home'], { queryParams: { returnUrl: state.url } });
    }
  } else {
    // On server-side, allow navigation (will be handled on client)
    return true;
  }
};
